<a
  class="get-back"
  (click)="backClicked()"
>
  <img src="../../../../../assets/images/return-arrow.svg" alt="return-arrow">
  <span>Back</span>
</a>
